import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  GetHlsPlaylist404,
  GetHlsPlaylistByPath404,
  GetHlsSegment404,
  GetHlsSegmentByPath404,
  GetLectureMarkdownSignedUrl200,
  GetLectureMarkdownSignedUrl403,
  GetLectureMarkdownSignedUrl404,
  GetLectureVideoSignedUrl200,
  GetLectureVideoSignedUrl403,
  GetLectureVideoSignedUrl404,
  GetMediaById200Two,
  GetMediaById404,
  GetMediaByPath404,
  GetStreamingInfo200,
  GetStreamingInfo404,
  GetStreamingInfoByPath200,
  GetStreamingInfoByPath404,
  UploadMedia201,
  UploadMedia400,
  UploadMediaBody
} from './types'


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;



/**
 * Minio에서 미디어 파일을 ID로 조회합니다.
 * @summary 미디어 파일 조회
 */
export const getMediaById = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob | GetMediaById200Two>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/media/${id}`,options
    );
  }


export const getGetMediaByIdQueryKey = (id: number,) => {
    return [`https://api.ugot.uk/api/media/${id}`] as const;
    }

    
export const getGetMediaByIdInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getMediaById>>, TError = AxiosError<void | GetMediaById404>>(id: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMediaById>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMediaByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMediaById>>> = ({ signal }) => getMediaById(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMediaById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMediaByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMediaById>>>
export type GetMediaByIdInfiniteQueryError = AxiosError<void | GetMediaById404>

/**
 * @summary 미디어 파일 조회
 */
export const useGetMediaByIdInfinite = <TData = Awaited<ReturnType<typeof getMediaById>>, TError = AxiosError<void | GetMediaById404>>(
 id: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMediaById>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMediaByIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetMediaByIdQueryOptions = <TData = Awaited<ReturnType<typeof getMediaById>>, TError = AxiosError<void | GetMediaById404>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMediaById>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMediaByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMediaById>>> = ({ signal }) => getMediaById(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMediaById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMediaByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMediaById>>>
export type GetMediaByIdQueryError = AxiosError<void | GetMediaById404>

/**
 * @summary 미디어 파일 조회
 */
export const useGetMediaById = <TData = Awaited<ReturnType<typeof getMediaById>>, TError = AxiosError<void | GetMediaById404>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMediaById>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMediaByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Minio에서 미디어 파일을 파일 경로로 직접 조회합니다.
 * @summary 파일 경로로 미디어 조회
 */
export const getMediaByPath = (
    path: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/media/file/${path}`,{
        responseType: 'blob',
    ...options,}
    );
  }


export const getGetMediaByPathQueryKey = (path: string,) => {
    return [`https://api.ugot.uk/api/media/file/${path}`] as const;
    }

    
export const getGetMediaByPathInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getMediaByPath>>, TError = AxiosError<void | GetMediaByPath404>>(path: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMediaByPath>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMediaByPathQueryKey(path);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMediaByPath>>> = ({ signal }) => getMediaByPath(path, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(path),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMediaByPath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMediaByPathInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMediaByPath>>>
export type GetMediaByPathInfiniteQueryError = AxiosError<void | GetMediaByPath404>

/**
 * @summary 파일 경로로 미디어 조회
 */
export const useGetMediaByPathInfinite = <TData = Awaited<ReturnType<typeof getMediaByPath>>, TError = AxiosError<void | GetMediaByPath404>>(
 path: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMediaByPath>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMediaByPathInfiniteQueryOptions(path,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetMediaByPathQueryOptions = <TData = Awaited<ReturnType<typeof getMediaByPath>>, TError = AxiosError<void | GetMediaByPath404>>(path: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMediaByPath>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMediaByPathQueryKey(path);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMediaByPath>>> = ({ signal }) => getMediaByPath(path, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(path),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMediaByPath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMediaByPathQueryResult = NonNullable<Awaited<ReturnType<typeof getMediaByPath>>>
export type GetMediaByPathQueryError = AxiosError<void | GetMediaByPath404>

/**
 * @summary 파일 경로로 미디어 조회
 */
export const useGetMediaByPath = <TData = Awaited<ReturnType<typeof getMediaByPath>>, TError = AxiosError<void | GetMediaByPath404>>(
 path: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMediaByPath>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMediaByPathQueryOptions(path,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Minio에 미디어 파일을 업로드합니다.
 * @summary 미디어 파일 업로드
 */
export const uploadMedia = (
    uploadMediaBody: UploadMediaBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UploadMedia201>> => {const formData = new FormData();
formData.append('file', uploadMediaBody.file)
if(uploadMediaBody.type !== undefined) {
 formData.append('type', uploadMediaBody.type)
 }
if(uploadMediaBody.description !== undefined) {
 formData.append('description', uploadMediaBody.description)
 }
if(uploadMediaBody.altText !== undefined) {
 formData.append('altText', uploadMediaBody.altText)
 }
if(uploadMediaBody.metadata !== undefined) {
 formData.append('metadata', uploadMediaBody.metadata)
 }

    
    return axios.post(
      `https://api.ugot.uk/api/media/upload`,
      formData,options
    );
  }



export const getUploadMediaMutationOptions = <TError = AxiosError<UploadMedia400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadMedia>>, TError,{data: UploadMediaBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof uploadMedia>>, TError,{data: UploadMediaBody}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadMedia>>, {data: UploadMediaBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadMedia(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadMediaMutationResult = NonNullable<Awaited<ReturnType<typeof uploadMedia>>>
    export type UploadMediaMutationBody = UploadMediaBody
    export type UploadMediaMutationError = AxiosError<UploadMedia400>

    /**
 * @summary 미디어 파일 업로드
 */
export const useUploadMedia = <TError = AxiosError<UploadMedia400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadMedia>>, TError,{data: UploadMediaBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof uploadMedia>>,
        TError,
        {data: UploadMediaBody},
        TContext
      > => {

      const mutationOptions = getUploadMediaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * HLS 비디오 스트리밍을 위한 정보를 조회합니다.
 * @summary 비디오 스트리밍 정보 조회
 */
export const getStreamingInfo = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetStreamingInfo200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/media/stream/${id}`,options
    );
  }


export const getGetStreamingInfoQueryKey = (id: number,) => {
    return [`https://api.ugot.uk/api/media/stream/${id}`] as const;
    }

    
export const getGetStreamingInfoInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getStreamingInfo>>, TError = AxiosError<GetStreamingInfo404>>(id: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreamingInfo>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamingInfoQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamingInfo>>> = ({ signal }) => getStreamingInfo(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreamingInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStreamingInfoInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getStreamingInfo>>>
export type GetStreamingInfoInfiniteQueryError = AxiosError<GetStreamingInfo404>

/**
 * @summary 비디오 스트리밍 정보 조회
 */
export const useGetStreamingInfoInfinite = <TData = Awaited<ReturnType<typeof getStreamingInfo>>, TError = AxiosError<GetStreamingInfo404>>(
 id: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreamingInfo>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetStreamingInfoInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetStreamingInfoQueryOptions = <TData = Awaited<ReturnType<typeof getStreamingInfo>>, TError = AxiosError<GetStreamingInfo404>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStreamingInfo>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamingInfoQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamingInfo>>> = ({ signal }) => getStreamingInfo(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreamingInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStreamingInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getStreamingInfo>>>
export type GetStreamingInfoQueryError = AxiosError<GetStreamingInfo404>

/**
 * @summary 비디오 스트리밍 정보 조회
 */
export const useGetStreamingInfo = <TData = Awaited<ReturnType<typeof getStreamingInfo>>, TError = AxiosError<GetStreamingInfo404>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStreamingInfo>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetStreamingInfoQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * HLS 비디오의 재생 목록(m3u8)을 조회합니다.
 * @summary HLS 재생 목록 조회
 */
export const getHlsPlaylist = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/media/stream/${id}/playlist.m3u8`,options
    );
  }


export const getGetHlsPlaylistQueryKey = (id: number,) => {
    return [`https://api.ugot.uk/api/media/stream/${id}/playlist.m3u8`] as const;
    }

    
export const getGetHlsPlaylistInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getHlsPlaylist>>, TError = AxiosError<GetHlsPlaylist404>>(id: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsPlaylist>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHlsPlaylistQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHlsPlaylist>>> = ({ signal }) => getHlsPlaylist(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsPlaylist>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHlsPlaylistInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getHlsPlaylist>>>
export type GetHlsPlaylistInfiniteQueryError = AxiosError<GetHlsPlaylist404>

/**
 * @summary HLS 재생 목록 조회
 */
export const useGetHlsPlaylistInfinite = <TData = Awaited<ReturnType<typeof getHlsPlaylist>>, TError = AxiosError<GetHlsPlaylist404>>(
 id: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsPlaylist>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHlsPlaylistInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetHlsPlaylistQueryOptions = <TData = Awaited<ReturnType<typeof getHlsPlaylist>>, TError = AxiosError<GetHlsPlaylist404>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHlsPlaylist>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHlsPlaylistQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHlsPlaylist>>> = ({ signal }) => getHlsPlaylist(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHlsPlaylist>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHlsPlaylistQueryResult = NonNullable<Awaited<ReturnType<typeof getHlsPlaylist>>>
export type GetHlsPlaylistQueryError = AxiosError<GetHlsPlaylist404>

/**
 * @summary HLS 재생 목록 조회
 */
export const useGetHlsPlaylist = <TData = Awaited<ReturnType<typeof getHlsPlaylist>>, TError = AxiosError<GetHlsPlaylist404>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHlsPlaylist>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHlsPlaylistQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * HLS 비디오의 특정 세그먼트(.ts 파일)를 조회합니다.
 * @summary HLS 세그먼트 조회
 */
export const getHlsSegment = (
    id: number,
    segmentId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/media/stream/${id}/segment/${segmentId}`,{
        responseType: 'blob',
    ...options,}
    );
  }


export const getGetHlsSegmentQueryKey = (id: number,
    segmentId: string,) => {
    return [`https://api.ugot.uk/api/media/stream/${id}/segment/${segmentId}`] as const;
    }

    
export const getGetHlsSegmentInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getHlsSegment>>, TError = AxiosError<GetHlsSegment404>>(id: number,
    segmentId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsSegment>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHlsSegmentQueryKey(id,segmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHlsSegment>>> = ({ signal }) => getHlsSegment(id,segmentId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id && segmentId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsSegment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHlsSegmentInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getHlsSegment>>>
export type GetHlsSegmentInfiniteQueryError = AxiosError<GetHlsSegment404>

/**
 * @summary HLS 세그먼트 조회
 */
export const useGetHlsSegmentInfinite = <TData = Awaited<ReturnType<typeof getHlsSegment>>, TError = AxiosError<GetHlsSegment404>>(
 id: number,
    segmentId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsSegment>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHlsSegmentInfiniteQueryOptions(id,segmentId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetHlsSegmentQueryOptions = <TData = Awaited<ReturnType<typeof getHlsSegment>>, TError = AxiosError<GetHlsSegment404>>(id: number,
    segmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHlsSegment>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHlsSegmentQueryKey(id,segmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHlsSegment>>> = ({ signal }) => getHlsSegment(id,segmentId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id && segmentId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHlsSegment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHlsSegmentQueryResult = NonNullable<Awaited<ReturnType<typeof getHlsSegment>>>
export type GetHlsSegmentQueryError = AxiosError<GetHlsSegment404>

/**
 * @summary HLS 세그먼트 조회
 */
export const useGetHlsSegment = <TData = Awaited<ReturnType<typeof getHlsSegment>>, TError = AxiosError<GetHlsSegment404>>(
 id: number,
    segmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHlsSegment>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHlsSegmentQueryOptions(id,segmentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 파일 경로로 HLS 비디오 스트리밍을 위한 정보를 조회합니다.
 * @summary 경로로 비디오 스트리밍 정보 조회
 */
export const getStreamingInfoByPath = (
    path: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetStreamingInfoByPath200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/media/stream/path/${path}`,options
    );
  }


export const getGetStreamingInfoByPathQueryKey = (path: string,) => {
    return [`https://api.ugot.uk/api/media/stream/path/${path}`] as const;
    }

    
export const getGetStreamingInfoByPathInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError = AxiosError<GetStreamingInfoByPath404>>(path: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamingInfoByPathQueryKey(path);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamingInfoByPath>>> = ({ signal }) => getStreamingInfoByPath(path, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(path),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStreamingInfoByPathInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getStreamingInfoByPath>>>
export type GetStreamingInfoByPathInfiniteQueryError = AxiosError<GetStreamingInfoByPath404>

/**
 * @summary 경로로 비디오 스트리밍 정보 조회
 */
export const useGetStreamingInfoByPathInfinite = <TData = Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError = AxiosError<GetStreamingInfoByPath404>>(
 path: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetStreamingInfoByPathInfiniteQueryOptions(path,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetStreamingInfoByPathQueryOptions = <TData = Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError = AxiosError<GetStreamingInfoByPath404>>(path: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamingInfoByPathQueryKey(path);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamingInfoByPath>>> = ({ signal }) => getStreamingInfoByPath(path, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(path),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStreamingInfoByPathQueryResult = NonNullable<Awaited<ReturnType<typeof getStreamingInfoByPath>>>
export type GetStreamingInfoByPathQueryError = AxiosError<GetStreamingInfoByPath404>

/**
 * @summary 경로로 비디오 스트리밍 정보 조회
 */
export const useGetStreamingInfoByPath = <TData = Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError = AxiosError<GetStreamingInfoByPath404>>(
 path: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStreamingInfoByPath>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetStreamingInfoByPathQueryOptions(path,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 파일 경로로 HLS 비디오의 재생 목록(m3u8)을 조회합니다.
 * @summary 경로로 HLS 재생 목록 조회
 */
export const getHlsPlaylistByPath = (
    path: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/media/stream/path/${path}/playlist.m3u8`,options
    );
  }


export const getGetHlsPlaylistByPathQueryKey = (path: string,) => {
    return [`https://api.ugot.uk/api/media/stream/path/${path}/playlist.m3u8`] as const;
    }

    
export const getGetHlsPlaylistByPathInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError = AxiosError<GetHlsPlaylistByPath404>>(path: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHlsPlaylistByPathQueryKey(path);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHlsPlaylistByPath>>> = ({ signal }) => getHlsPlaylistByPath(path, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(path),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHlsPlaylistByPathInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getHlsPlaylistByPath>>>
export type GetHlsPlaylistByPathInfiniteQueryError = AxiosError<GetHlsPlaylistByPath404>

/**
 * @summary 경로로 HLS 재생 목록 조회
 */
export const useGetHlsPlaylistByPathInfinite = <TData = Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError = AxiosError<GetHlsPlaylistByPath404>>(
 path: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHlsPlaylistByPathInfiniteQueryOptions(path,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetHlsPlaylistByPathQueryOptions = <TData = Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError = AxiosError<GetHlsPlaylistByPath404>>(path: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHlsPlaylistByPathQueryKey(path);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHlsPlaylistByPath>>> = ({ signal }) => getHlsPlaylistByPath(path, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(path),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHlsPlaylistByPathQueryResult = NonNullable<Awaited<ReturnType<typeof getHlsPlaylistByPath>>>
export type GetHlsPlaylistByPathQueryError = AxiosError<GetHlsPlaylistByPath404>

/**
 * @summary 경로로 HLS 재생 목록 조회
 */
export const useGetHlsPlaylistByPath = <TData = Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError = AxiosError<GetHlsPlaylistByPath404>>(
 path: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHlsPlaylistByPath>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHlsPlaylistByPathQueryOptions(path,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 파일 경로로 HLS 비디오의 특정 세그먼트(.ts 파일)를 조회합니다.
 * @summary 경로로 HLS 세그먼트 조회
 */
export const getHlsSegmentByPath = (
    path: string,
    segmentId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/media/stream/path/${path}/segment/${segmentId}`,{
        responseType: 'blob',
    ...options,}
    );
  }


export const getGetHlsSegmentByPathQueryKey = (path: string,
    segmentId: string,) => {
    return [`https://api.ugot.uk/api/media/stream/path/${path}/segment/${segmentId}`] as const;
    }

    
export const getGetHlsSegmentByPathInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError = AxiosError<GetHlsSegmentByPath404>>(path: string,
    segmentId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHlsSegmentByPathQueryKey(path,segmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHlsSegmentByPath>>> = ({ signal }) => getHlsSegmentByPath(path,segmentId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(path && segmentId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHlsSegmentByPathInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getHlsSegmentByPath>>>
export type GetHlsSegmentByPathInfiniteQueryError = AxiosError<GetHlsSegmentByPath404>

/**
 * @summary 경로로 HLS 세그먼트 조회
 */
export const useGetHlsSegmentByPathInfinite = <TData = Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError = AxiosError<GetHlsSegmentByPath404>>(
 path: string,
    segmentId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHlsSegmentByPathInfiniteQueryOptions(path,segmentId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetHlsSegmentByPathQueryOptions = <TData = Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError = AxiosError<GetHlsSegmentByPath404>>(path: string,
    segmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHlsSegmentByPathQueryKey(path,segmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHlsSegmentByPath>>> = ({ signal }) => getHlsSegmentByPath(path,segmentId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(path && segmentId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHlsSegmentByPathQueryResult = NonNullable<Awaited<ReturnType<typeof getHlsSegmentByPath>>>
export type GetHlsSegmentByPathQueryError = AxiosError<GetHlsSegmentByPath404>

/**
 * @summary 경로로 HLS 세그먼트 조회
 */
export const useGetHlsSegmentByPath = <TData = Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError = AxiosError<GetHlsSegmentByPath404>>(
 path: string,
    segmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHlsSegmentByPath>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHlsSegmentByPathQueryOptions(path,segmentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 지정된 강의의 비디오 콘텐츠에 접근하기 위한 시간 제한 Signed URL을 반환합니다. 사용자는 해당 강의에 수강 등록되어 있어야 합니다.
 * @summary 강의 비디오 Signed URL 조회
 */
export const getLectureVideoSignedUrl = (
    courseId: number,
    lectureId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetLectureVideoSignedUrl200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/courses/${courseId}/lectures/${lectureId}/video-url`,options
    );
  }


export const getGetLectureVideoSignedUrlQueryKey = (courseId: number,
    lectureId: number,) => {
    return [`https://api.ugot.uk/api/courses/${courseId}/lectures/${lectureId}/video-url`] as const;
    }

    
export const getGetLectureVideoSignedUrlInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getLectureVideoSignedUrl>>, TError = AxiosError<GetLectureVideoSignedUrl403 | GetLectureVideoSignedUrl404>>(courseId: number,
    lectureId: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLectureVideoSignedUrl>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLectureVideoSignedUrlQueryKey(courseId,lectureId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLectureVideoSignedUrl>>> = ({ signal }) => getLectureVideoSignedUrl(courseId,lectureId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(courseId && lectureId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLectureVideoSignedUrl>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLectureVideoSignedUrlInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLectureVideoSignedUrl>>>
export type GetLectureVideoSignedUrlInfiniteQueryError = AxiosError<GetLectureVideoSignedUrl403 | GetLectureVideoSignedUrl404>

/**
 * @summary 강의 비디오 Signed URL 조회
 */
export const useGetLectureVideoSignedUrlInfinite = <TData = Awaited<ReturnType<typeof getLectureVideoSignedUrl>>, TError = AxiosError<GetLectureVideoSignedUrl403 | GetLectureVideoSignedUrl404>>(
 courseId: number,
    lectureId: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLectureVideoSignedUrl>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetLectureVideoSignedUrlInfiniteQueryOptions(courseId,lectureId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetLectureVideoSignedUrlQueryOptions = <TData = Awaited<ReturnType<typeof getLectureVideoSignedUrl>>, TError = AxiosError<GetLectureVideoSignedUrl403 | GetLectureVideoSignedUrl404>>(courseId: number,
    lectureId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLectureVideoSignedUrl>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLectureVideoSignedUrlQueryKey(courseId,lectureId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLectureVideoSignedUrl>>> = ({ signal }) => getLectureVideoSignedUrl(courseId,lectureId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(courseId && lectureId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLectureVideoSignedUrl>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLectureVideoSignedUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getLectureVideoSignedUrl>>>
export type GetLectureVideoSignedUrlQueryError = AxiosError<GetLectureVideoSignedUrl403 | GetLectureVideoSignedUrl404>

/**
 * @summary 강의 비디오 Signed URL 조회
 */
export const useGetLectureVideoSignedUrl = <TData = Awaited<ReturnType<typeof getLectureVideoSignedUrl>>, TError = AxiosError<GetLectureVideoSignedUrl403 | GetLectureVideoSignedUrl404>>(
 courseId: number,
    lectureId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLectureVideoSignedUrl>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetLectureVideoSignedUrlQueryOptions(courseId,lectureId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 지정된 강의의 마크다운 콘텐츠에 접근하기 위한 시간 제한 Signed URL을 반환합니다. 사용자는 해당 강의에 수강 등록되어 있어야 합니다.
 * @summary 강의 마크다운 Signed URL 조회
 */
export const getLectureMarkdownSignedUrl = (
    courseId: number,
    lectureId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetLectureMarkdownSignedUrl200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/courses/${courseId}/lectures/${lectureId}/markdown-url`,options
    );
  }


export const getGetLectureMarkdownSignedUrlQueryKey = (courseId: number,
    lectureId: number,) => {
    return [`https://api.ugot.uk/api/courses/${courseId}/lectures/${lectureId}/markdown-url`] as const;
    }

    
export const getGetLectureMarkdownSignedUrlInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getLectureMarkdownSignedUrl>>, TError = AxiosError<GetLectureMarkdownSignedUrl403 | GetLectureMarkdownSignedUrl404>>(courseId: number,
    lectureId: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLectureMarkdownSignedUrl>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLectureMarkdownSignedUrlQueryKey(courseId,lectureId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLectureMarkdownSignedUrl>>> = ({ signal }) => getLectureMarkdownSignedUrl(courseId,lectureId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(courseId && lectureId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLectureMarkdownSignedUrl>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLectureMarkdownSignedUrlInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLectureMarkdownSignedUrl>>>
export type GetLectureMarkdownSignedUrlInfiniteQueryError = AxiosError<GetLectureMarkdownSignedUrl403 | GetLectureMarkdownSignedUrl404>

/**
 * @summary 강의 마크다운 Signed URL 조회
 */
export const useGetLectureMarkdownSignedUrlInfinite = <TData = Awaited<ReturnType<typeof getLectureMarkdownSignedUrl>>, TError = AxiosError<GetLectureMarkdownSignedUrl403 | GetLectureMarkdownSignedUrl404>>(
 courseId: number,
    lectureId: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLectureMarkdownSignedUrl>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetLectureMarkdownSignedUrlInfiniteQueryOptions(courseId,lectureId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetLectureMarkdownSignedUrlQueryOptions = <TData = Awaited<ReturnType<typeof getLectureMarkdownSignedUrl>>, TError = AxiosError<GetLectureMarkdownSignedUrl403 | GetLectureMarkdownSignedUrl404>>(courseId: number,
    lectureId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLectureMarkdownSignedUrl>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLectureMarkdownSignedUrlQueryKey(courseId,lectureId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLectureMarkdownSignedUrl>>> = ({ signal }) => getLectureMarkdownSignedUrl(courseId,lectureId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(courseId && lectureId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLectureMarkdownSignedUrl>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLectureMarkdownSignedUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getLectureMarkdownSignedUrl>>>
export type GetLectureMarkdownSignedUrlQueryError = AxiosError<GetLectureMarkdownSignedUrl403 | GetLectureMarkdownSignedUrl404>

/**
 * @summary 강의 마크다운 Signed URL 조회
 */
export const useGetLectureMarkdownSignedUrl = <TData = Awaited<ReturnType<typeof getLectureMarkdownSignedUrl>>, TError = AxiosError<GetLectureMarkdownSignedUrl403 | GetLectureMarkdownSignedUrl404>>(
 courseId: number,
    lectureId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLectureMarkdownSignedUrl>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetLectureMarkdownSignedUrlQueryOptions(courseId,lectureId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



